<template>
  <commonTable
    :fields="totalProduceTableFields"
    :items="totalProduceTimeItem"
    :otherTheme="'thead-green'"
  >
    <template #cell(startTime)="data">
      <template v-if="data.value == '' || data.value == null">-</template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(endTime)="data">
      <template v-if="data.value == '' || data.value == null">-</template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(device_name)="data">
      <template v-if="modStatus">
        <input
          type="text"
          @blur="checkChangeInput('device_name', data.index)"
          v-model="totalProduceTimeItem[data.index].device_name"
          style="width: 100%; height: 100%"
          class="text-center"
          name="totalProduceDeviceName"
        />
      </template>
      <template v-else>{{ data.value }}</template>
    </template>
  </commonTable>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  name: "totalProduceTable",
  components: {
    commonTable,
  },
  props: {
    processID: {
      type: Number,
    },
    totalProduceTimeItem: {
      type: Array,
      default: [],
    },
    reason: {
      type: Array,
      default: [],
    },
    modStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const path = inject("path");

    //查詢結果表格
    const totalProduceTableFields = ref([]);

    const setField = () => {
      // if (props.modStatus == false) {
      totalProduceTableFields.value = [
        {
          key: "code",
          label: "製程",
          thStyle: {
            "min-width": "150px",
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "device_name",
          label: "機台編號",
          thStyle: {
            "min-width": "150px",
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "startTime",
          label: "開始時間",
          thStyle: {
            "min-width": "300px",
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "endTime",
          label: "結束時間",
          thStyle: {
            "min-width": "300px",
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "totalTime",
          label: "生產時間",
          thStyle: {
            "min-width": "225px",
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
      ];
      // } else if (props.modStatus == true) {
      // }
    };

    const checkChangeInput = (position, index = null) => {
      switch (position) {
        case "device_name":
          console.log("device_name");
          let device_name = props.totalProduceTimeItem[index].device_name;
          if (device_name == "" || device_name == undefined) {
            props.totalProduceTimeItem[index].device_name =
              props.totalProduceTimeItem[index].orgDevice_name;
            methods.setTimeoutAlert(`機台編號不可為空，請再次確認`);
            return;
          }
          var params = {};
          params["webPage"] =
            sideNavPath.value.length != 0
              ? sideNavPath.value[sideNavPath.value.length - 1]
              : null;
          params["user"] = loginData.value.account;
          params["vuePage"] = path.value;
          params["methods"] = "POST";
          params["device_name"] = device_name;
          params["whichFunction"] = "checkChangeInput";
          methods.axiosAction(params).then(() => {
            let result = axiosResult.value;
            if (result["Response"] == "ok") {
              if (props.processID != result["QueryValueData"]) {
                methods.setTimeoutAlert(`該製程無此機台編號，請再次確認`);
                props.totalProduceTimeItem[index].device_name =
                  props.totalProduceTimeItem[index].orgDevice_name;
                return;
              }
              props.totalProduceTimeItem[index].orgDevice_name = device_name;

              var queryIndex =
                props.totalProduceTimeItem[index].reason.indexOf("device_name");
              if (
                props.totalProduceTimeItem[index].in_device_name != device_name
              ) {
                if (queryIndex == -1) {
                  props.totalProduceTimeItem[index].reason.push("device_name");
                }
              } else {
                //舊的跟新的一樣
                if (queryIndex != -1) {
                  props.totalProduceTimeItem[index].reason.splice(
                    queryIndex,
                    1
                  );
                }
              }
            } else {
              methods.setTimeoutAlert(`查無此機台編號，請再次確認`);
              props.totalProduceTimeItem[index].device_name =
                props.totalProduceTimeItem[index].orgDevice_name;
              return;
            }
          });
          break;
        default:
          break;
      }
    };

    watch(
      () => props.modStatus,
      () => {
        setField();
      },
      { deep: true }
    );

    setField();

    return {
      totalProduceTableFields,
      checkChangeInput,
    };
  },
};
</script>

<style></style>
